import { render } from "./BaseView.vue?vue&type=template&id=2abc0770&ts=true"
import script from "./BaseView.vue?vue&type=script&lang=ts"
export * from "./BaseView.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/gestcoop/gestcoop-client-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__